import React, { useState } from 'react';
import classes from "./checkout.module.css";
import { sixYardAxios } from '../../../../sixYardAxios';
import DoubleArrow from "../../../../assets/images/red-arrow.png";
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Checkout = (props) => {
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;

    const amountAfterDiscountOrWelcomeKit =
        ((Number(props.paymentData?.payment_summary?.amount) || 0) +
            (Number(props.paymentData?.payment_summary?.welcome_kit?.price) || 0) -
            (Number(props.paymentData?.payment_summary?.discount?.amount) || 0));
    const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
    const [partialValue, setPartialValue] = useState(10);
    const [loyalty, setLoyalty] = useState(0);
    const [checkLoyaltyEnteredAmount, setCheckLoyaltyEnteredAmount] = useState(null);
    const [error, setError] = useState(null);
    const [totalAmount, setTotalAmount] = useState(amountAfterDiscountOrWelcomeKit);
    const [paymentType, setPaymentType] = useState("full");
    const [loading, setLoading] = useState(false); 
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.registrationId,
                amount: paymentType === "full" ? totalAmount : partialValue,
                payment_type: paymentType,
                loyalty_points_used: loyaltyPointsUsed,
                customer_name: "",
                customer_email: ""
            };
            const response = await sixYardAxios.post('/payments/initiate/academy', formData);
            if (response.data.data) {
                const redirectUrl = response.data.data.redirect_url;
                localStorage.removeItem("academyRegistrationFormStudent");
                localStorage.removeItem("academyRegistrationFormWaiver");
                props.showAcademyRegistrationForm(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                if (redirectUrl) {
                    window.open(redirectUrl, '_blank');
                }
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const calculateLoyaltyAmount = (e) => {
        if (e.target.value <= props.paymentData?.payment_summary?.loyalty_points_available) {
            setLoyalty(e.target.value);
        } else {
            setCheckLoyaltyEnteredAmount(isEnglish ? "The amount you enter is greater than your points" : "المبلغ الذي أدخلته أكبر من نقاطك");
        }
    };

    const closeLoyaltyIssue = () => {
        setCheckLoyaltyEnteredAmount(null);
        setLoyalty("");
    };

    const loyaltySubmitHandler = (e) => {
        e.preventDefault();
        setLoyaltyPointsUsed(loyalty);
        setTotalAmount(amountAfterDiscountOrWelcomeKit - loyalty);
    };

    return (
        <div className={classes.Container}>
            {/* ✅ Loader Overlay */}
            {loading && (
                <div className={classes.LoadingOverlay}>
                    <div className={classes.Spinner}></div>
                    <p>{isEnglish ? "Processing Payment..." : "جاري معالجة الدفع..."}</p>
                </div>
            )}

            <div className={classes.Content}>
                {props.paymentData?.payment_summary?.welcome_kit?.price > 0 && (
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>{props.paymentData?.payment_summary?.welcome_kit?.note}</div>
                    </div>
                )}

                <div className={classes.BookingSummery}>
                    <h3>{isEnglish ? "Booking Summary" : "ملخص الحجز"}</h3>
                    <div className={classes.info}>
                        <p>{props.bookingData?.dates?.start} to {props.bookingData?.dates?.end}</p>
                        <p>{props.bookingData?.location}, {isEnglish ? "Academy" : "الأكاديمية"}</p>
                    </div>
                    <div>
                        {isEnglish ? "You have" : "لديك"}
                        <span className={classes.money}> {props.paymentData?.payment_summary?.loyalty_points_available} JD </span>
                        {isEnglish ? "from loyalty program, enter the amount you desire to use." : "من برنامج الولاء، أدخل المبلغ الذي ترغب في استخدامه."}
                    </div>
                    <form onSubmit={loyaltySubmitHandler}>
                        <label>{isEnglish ? "Amount" : "المبلغ"}</label><br />
                        <input
                            placeholder={isEnglish ? 'Enter amount' : 'أدخل المبلغ'}
                            value={loyalty}
                            onChange={calculateLoyaltyAmount}
                        />
                        <button type='submit'>{isEnglish ? "Calculate" : "احسب"}</button>
                    </form>
                </div>

                <div className={classes.PaymentSummery}>
                    <h3>{isEnglish ? "Payment Summary" : "ملخص الدفع"}</h3>
                    <div>
                        <span>{isEnglish ? "Base Amount" : "المبلغ الأساسي"}</span>
                        <span>{props.paymentData?.payment_summary?.amount} JD</span>
                    </div>
                    {props.paymentData?.payment_summary?.welcome_kit?.price > 0 && (
                        <div>
                            <span>{isEnglish ? "Welcome Kit" : "طقم الترحيب"}</span>
                            <span>{props.paymentData?.payment_summary?.welcome_kit?.price} JD</span>
                        </div>
                    )}
                    {props.paymentData?.payment_summary?.discount?.amount > 0 && (
                        <div>
                            <span>{isEnglish ? "Discount" : "الخصم"}</span>
                            <span className={classes.Zero}>-{props.paymentData?.payment_summary?.discount?.amount} JD</span>
                        </div>
                    )}
                    <div className={classes.LoyaltyPoints}>
                        <span>{isEnglish ? "Loyalty Program Points" : "نقاط برنامج الولاء"}</span>
                        <span className={classes.Zero}>{loyaltyPointsUsed || 0} JD</span>
                    </div>
                    <div className={classes.Total}>
                        <span>{isEnglish ? "Total" : "المجموع"}</span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>

                <div>
                    <h3>{isEnglish ? "Payment Amount" : "مبلغ الدفع"}</h3>
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>{isEnglish ? "You can pay full amount" : "يمكنك دفع المبلغ كاملاً"}</div>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input
                                type="radio"
                                checked={paymentType === "full"}
                                value="full"
                                onChange={() => setPaymentType("full")}
                            />
                            <label className={classes.Label}>{isEnglish ? "Full Amount" : "المبلغ كاملاً"}</label>
                        </span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>

                <div>
                    <form className={classes.FormContainer} onSubmit={submitHandler}>
                        <div className={classes.Buttons}>
                            <button type="button" onClick={backHandler}>
                                {isEnglish ? (
                                    <><img src={DoubleArrow} alt="" className={classes.Icon} /> BACK</>
                                ) : (
                                    <><img src={DoubleArrow} alt="" className={[classes.Icon, classes.ReverseIcon].join(" ")} /> رجوع</>
                                )}
                            </button>
                            <button type="submit" disabled={loading}>
                                {loading
                                    ? (isEnglish ? "PROCESSING..." : "جارٍ المعالجة")
                                    : (isEnglish ? "CHECKOUT" : "الدفع")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* ✅ Error modals */}
            {error && <PromptMessage message={error} status={isEnglish ? 'Oops' : 'عفواً'} button={isEnglish ? 'CLOSE' : 'إغلاق'} click={() => setError(false)} />}
            {checkLoyaltyEnteredAmount && <PromptMessage message={checkLoyaltyEnteredAmount} status={isEnglish ? 'Oops' : 'عفواً'} button={isEnglish ? 'CLOSE' : 'إغلاق'} click={closeLoyaltyIssue} />}
        </div>
    );
};

export default Checkout;
